import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import DynamicFormField from 'components/form/DynamicFormField';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SaveIcon from '@mui/icons-material/Save';
import Typography from '@mui/material/Typography';

const TaxConfigurationTab = ({ configFormData, handleConfigInputChange, handleSaveConfig, updateConfig }) => {
    const configFields = [
        {
            id: "aliquota_seg_int",
            label: "International Insurance Rate",
            type: "percentage",
            mdColSpan: 6,
            handleInputChange: handleConfigInputChange,
            value: configFormData?.aliquota_seg_int,
            inputProps: {
                step: "0.01",
                min: "0",
                max: "100"
            }
        },
        {
            id: "pis_cofins_taxa",
            label: "PIS/COFINS Tax Rate",
            type: "percentage",
            mdColSpan: 6,
            handleInputChange: handleConfigInputChange,
            value: configFormData?.pis_cofins_taxa,
            inputProps: {
                step: "0.01",
                min: "0",
                max: "100"
            }
        },
        {
            id: "credit_pis_pasep_rate",
            label: "PIS/PASEP Credit Rate",
            type: "percentage",
            mdColSpan: 6,
            handleInputChange: handleConfigInputChange,
            value: configFormData?.credit_pis_pasep_rate,
            inputProps: {
                step: "0.01",
                min: "0",
                max: "100"
            }
        },
        {
            id: "credit_cofins_rate",
            label: "COFINS Credit Rate",
            type: "percentage",
            mdColSpan: 6,
            handleInputChange: handleConfigInputChange,
            value: configFormData?.credit_cofins_rate,
            inputProps: {
                step: "0.01",
                min: "0",
                max: "100"
            }
        }
    ];

    return (
        <Card>
            <CardContent>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="h5">
                        Tax Configuration
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<SaveIcon />}
                        onClick={handleSaveConfig}
                        disabled={updateConfig.isLoading}
                    >
                        Save Changes
                    </Button>
                </Box>
                <Grid container spacing={2}>
                    {configFields.map(field => (
                        <DynamicFormField
                            key={field.id}
                            field={field}
                            formData={configFormData}
                        />
                    ))}
                </Grid>
            </CardContent>
        </Card>
    );
};

export default TaxConfigurationTab;